import { useEffect, useState } from "react"
import { useWebsiteAttribute } from "../hooks/useAttributes"
import { useCategories } from "@/hooks/useCategories"

export const FilterSidebar = ({
  selectedSizes,
  setSelectedSizes,
  selectedColors,
  setSelectedColors,
  selectedCategories,
  setSelectedCategories,
}) => {
  const { data: attributes } = useWebsiteAttribute()
  const { data: categoriesData } = useCategories()

  const categories =
    categoriesData?.data?.data || categoriesData?.data || []

  const [size, setSize] = useState([])
  const [color, setColor] = useState([])

  // Show more states
  const [showAllSizes, setShowAllSizes] = useState(false)
  const [showAllColors, setShowAllColors] = useState(false)

  useEffect(() => {
    if (!attributes?.data) return

    const sizes = []
    const colors = []

    attributes.data.forEach((att) => {
      if (att.setting_value === "size") {
        sizes.push(att)
      }

      if (att.setting_value === "color") {
        colors.push(att)
      }
    })

    setSize(sizes)
    setColor(colors)
  }, [attributes?.data])

  const toggleSize = (id) => {
    setSelectedSizes((prev) => {
      if (prev.includes(id)) {
        return prev.filter((s) => s !== id)
      } else {
        return [...prev, id]
      }
    })
  }

  const toggleColor = (id) => {
    setSelectedColors((prev) => {
      if (prev.includes(id)) {
        return prev.filter((c) => c !== id)
      } else {
        return [...prev, id]
      }
    })
  }

  const toggleCategory = (id) => {
    setSelectedCategories((prev) => {
      if (prev.includes(id)) {
        return prev.filter((c) => c !== id)
      } else {
        return [...prev, id]
      }
    })
  }

  const clearFilters = () => {
    setSelectedSizes([])
    setSelectedColors([])
    setSelectedCategories([])
  }

  const visibleSizes = showAllSizes ? size : size.slice(0, 12)
  const visibleColors = showAllColors ? color : color.slice(0, 12)

  return (
    <div className="bg-white border rounded-lg p-5 space-y-6 sticky top-24 h-fit max-h-[calc(100vh-7rem)] overflow-y-auto">
      {/* Categories */}
      <div>
        <h4 className="font-semibold text-gray-900 mb-3">Categories</h4>
        <div className="space-y-2 text-sm">
          {categories.map((cat) => (
            <label key={cat.id} className="flex items-center gap-2">
              <input
                type="checkbox"
                className="rounded border-gray-300"
                checked={selectedCategories.includes(cat.id)}
                onChange={() => toggleCategory(cat.id)}
              />
              <span>{cat.name}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Size Filter */}
      <div>
        <h4 className="font-semibold text-gray-900 mb-3">Size</h4>
        <div className="flex flex-wrap gap-2">
          {visibleSizes.map((size) => (
            <button
              key={size.id}
              onClick={() => toggleSize(size.id)}
              className={`px-3 py-1 border rounded text-sm hover:bg-gray-100 ${
                selectedSizes.includes(size.id)
                  ? "bg-indigo-600 text-white hover:bg-indigo-700"
                  : ""
              }`}
            >
              {size.attribute}
            </button>
          ))}
        </div>
        {size.length > 12 && (
          <button
            onClick={() => setShowAllSizes(!showAllSizes)}
            className="text-xs text-indigo-600 hover:underline mt-2"
          >
            {showAllSizes ? "Show Less" : "Show More"}
          </button>
        )}
      </div>

      {/* Color Filter */}
      <div>
        <h4 className="font-semibold text-gray-900 mb-3">Color</h4>
        <div className="flex flex-wrap gap-3">
          {visibleColors.map((c) => (
            <button
              key={c.id}
              title={c.attribute}
              onClick={() => toggleColor(c.id)}
              className={`w-6 h-6 rounded-full border ${
                selectedColors.includes(c.id)
                  ? "ring-2 ring-offset-2 ring-indigo-600"
                  : ""
              }`}
              style={{ backgroundColor: c.attribute.toLowerCase() }}
            />
          ))}
        </div>
        {color.length > 12 && (
          <button
            onClick={() => setShowAllColors(!showAllColors)}
            className="text-xs text-indigo-600 hover:underline mt-2"
          >
            {showAllColors ? "Show Less" : "Show More"}
          </button>
        )}
      </div>

      {/* Price (UI only) */}
      {/* <div>
        <h4 className="font-semibold text-gray-900 mb-3">Price</h4>
        <input type="range" min="0" max="500" className="w-full" />
        <div className="flex justify-between text-xs text-gray-500 mt-1">
          <span>$0</span>
          <span>$500</span>
        </div>
      </div> */}

      {/* Clear */}
      <button
        onClick={clearFilters}
        className="w-full text-sm text-indigo-600 hover:underline"
      >
        Clear Filters
      </button>
    </div>
  )
}
